'use strict';
import get from 'lodash/get';
import {ASSET_PROJECT_COLLECTION, PROJECT_COLLECTION} from '../../projects/domain/config';
import {
  ASSET_FILE_REQUIREMENT_COLLECTION,
  ASSET_FORM_REQUIREMENT_COLLECTION,
  FILE_REQUIREMENT_COLLECTION,
  FORM_REQUIREMENT_COLLECTION,
} from '../../requirements/domain/config';
import {ASSET_TASK_COLLECTION, TASK_COLLECTION} from '../../tasks/domain/config';


FeedEntryService.$inject = [
  '$translate',
  '$domain',
  '$toast',
  'appNavigatorService',
  'PersonnelService',
  'TaskStatusService',
  'ActivityFeedDomain',
  'PersonDomain',
  'TeamDomain',
];

export function FeedEntryService(
  $translate,
  $domain,
  $toast,
  appNavigatorService,
  PersonnelService,
  TaskStatusService,
  ActivityFeedDomain,
  PersonDomain,
  TeamDomain,
) {
  this.buildData = buildData;
  this.goToTarget = goToTarget;

  function goToTarget(entry) {
    if (entry) {
      const link = ActivityFeedDomain.getFeedTarget(entry);
      return appNavigatorService.goToLink(link)
        .catch(() => $toast.showMessage('Could not find source!', null, $toast.TOAST_TYPES.error));
    } else {
      return Promise.resolve(null);
    }
  }

  /**
   *
   * @param feedEntry
   * @param {Object} props
   * @param {string} props.id
   * @param {string} props.collection
   * @param {string} [props.type]
   * @param {boolean} [props.isOwnFeed]
   * @returns {*}
   */
  function buildData(feedEntry, props) {
    if (!feedEntry.feedable || !feedEntry.feedable.collection)
      return Promise.resolve(null);

    // shallow clone feedEntry
    const feedData = {
      ...feedEntry,
    };
    const messageCode = props.isOwnFeed && feedEntry.msg.indexOf('.self') === -1
      ? feedEntry.msg + '.self'
      : feedEntry.msg;
    let processParams;
    let updateMethod;

    try {
      if (feedEntry.type.indexOf('status') > -1) {
        feedData.icon = TaskStatusService.getStatusIcon(feedEntry.data.c_status, true);
        processParams = ActivityFeedDomain.processEntryData(feedEntry, _getLinkCallback, props)
          .then(paramData => _processStatusParams(paramData));
      } else {
        feedData.icon = feedEntry.type;
        processParams = ActivityFeedDomain.processEntryData(feedEntry, _getLinkCallback, props);
      }
    } catch (e) {
      return Promise.reject(e);
    }

    switch (feedEntry.feedable.collection) {
      case TASK_COLLECTION:
      case ASSET_TASK_COLLECTION:
        feedData.tagName = 'task';
        updateMethod = _updateForTask;
        break;
      case PROJECT_COLLECTION:
      case ASSET_PROJECT_COLLECTION:
        feedData.tagName = 'project';
        updateMethod = _updateForTask;
        break;
      case FILE_REQUIREMENT_COLLECTION:
      case FORM_REQUIREMENT_COLLECTION:
      case ASSET_FILE_REQUIREMENT_COLLECTION:
      case ASSET_FORM_REQUIREMENT_COLLECTION:
        feedData.tagName = 'req';
        updateMethod = _updateForTask;
        break;
      case PersonDomain.COLLECTION:
        feedData.tagName = 'person';
        updateMethod = _updateForTask;
        break;
      case TeamDomain.COLLECTION:
        feedData.tagName = 'team';
        updateMethod = _updateForTask;
        break;
    }

    return processParams.then(paramData => {
      if (!get(paramData, 'changedBy'))
        paramData.changedBy = 'System'; // TODO: replace short term workaround
      if (updateMethod)
        return updateMethod(feedEntry, paramData);
    }).then(() => feedData);

    function _updateForTask(model, paramData) {
      return $translate(messageCode, paramData).then(msg => feedData.message = msg);
    }
  }

  function _processStatusParams(paramData) {
    return Promise.props({
      c_status: _getStatusName(paramData.c_status),
      p_status: _getStatusName(paramData.p_status),
    }).then(results => {
      paramData.c_status = results.c_status;
      paramData.p_status = results.p_status;
      return paramData;
    });
  }

  function _getStatusName(status) {
    return status ? $translate('status.' + status + '.label') : Promise.resolve('');
  }

  function _getLinkCallback(link) {
    if (!link.id || !link.collection) {
      return Promise.resolve(null);
    } else if (link.collection === PersonDomain.COLLECTION) {
      return PersonnelService.getNameAsync(link.id);
    } else {
      return $domain.getDomain(link.collection)
        .$get(link.id)
        .catch(_resolveNull);
    }
  }

  function _resolveNull() {
    return null;
  }
}



// WEBPACK FOOTER //
// ./src/js/activity-feed/services/FeedEntryService.js